import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, pointAnchor } from '../../ui';
import type { MenuAction, MenuItem } from './menu-items';

/**
 * Context menu at client coordinates, on the ui `Menu` (P16-2): arrows, Home and End move, Escape from anywhere and
 * a press outside close it, as does the editor on pan. The editor gives the focus back to the canvas in `onClose`.
 */
export function ContextMenu({ items, x, y, onAction, onClose }: { items: MenuItem[]; x: number; y: number; onAction: (id: MenuAction) => void; onClose: () => void }) {
  const { t } = useTranslation();
  const anchor = useMemo(() => pointAnchor(x, y), [x, y]);
  return (
    <Menu.Root open modal={false} loopFocus onOpenChange={(open) => !open && onClose()}>
      <Menu.Popup label={t('menu.label')} anchor={anchor} sideOffset={0} finalFocus={false} focusFirst className="min-w-52">
        {items.map((it, i) =>
          'separator' in it ? (
            <Menu.Separator key={`sep-${i}`} />
          ) : (
            <Menu.Item key={it.id} disabled={it.disabled} onClick={() => onAction(it.id)} className={it.danger ? 'text-danger' : undefined}>
              {t(`menu.${it.id}`)}
            </Menu.Item>
          ),
        )}
      </Menu.Popup>
    </Menu.Root>
  );
}
